import { apiPost } from '@/lib/http/client';

import type { StripeBackfillDepth } from '../types';

export function getStripeAuthorizeUrl(orgId: number | string): string {
  return `/api/orgs/${orgId}/integrations/stripe/authorize/`;
}

export async function disconnectStripe(
  orgId: number | string,
  connectionId: string
): Promise<{ success: boolean; message?: string }> {
  return apiPost(
    `/api/orgs/${orgId}/integrations/stripe/${encodeURIComponent(connectionId)}/disconnect/`,
    {}
  );
}

export async function startStripeBackfill(
  orgId: number | string,
  connectionId: string,
  depth: StripeBackfillDepth
): Promise<{ success: boolean }> {
  return apiPost(
    `/api/orgs/${orgId}/integrations/stripe/${encodeURIComponent(connectionId)}/backfill/`,
    { depth }
  );
}
